import React from 'react';
import { SOURCE_BUCKET_LABELS } from '../../../utils/accuracyEvidenceMeta';
import styles from '../css/index.module.css';

const TONE_CLASS = {
    proof: styles.aiWardenEvidenceBadgeProof,
    management: styles.aiWardenEvidenceBadgeManagement,
    consultant: styles.aiWardenEvidenceBadgeConsultant,
};

const EvidenceSourceBadge = ({ bucket, label }) => {
    const text = label || SOURCE_BUCKET_LABELS[bucket] || bucket;
    if (!text) return null;
    const tone = TONE_CLASS[bucket] || styles.aiWardenEvidenceBadgeNeutral;
    return (
        <span className={`${styles.aiWardenEvidenceBadge} ${tone}`}>{text}</span>
    );
};

export default EvidenceSourceBadge;
